<template>
  <div
    v-if="hasPermission(permissions.buyContractsCreate)"
    class="buy-contract"
  >
    <content-header>{{ $t("createBuyContract") }}</content-header>
    <v-content>
      <b-card>
        <b-card-body>
          <b-row>
            <b-col>
              <select-input
                id="property"
                :name="$t('property')"
                label="name,+propertyTypeName"
                api-link="properties/GET_ALL"
                :api-params="{ OnlyAvailable: true }"
                @itemSelected="propertySelected"
                :return-object="true"
              />
              <select-input
                id="customers"
                :name="
                  projectTenant() === 'MassHills'
                    ? $t('buyers')
                    : $t('customers')
                "
                label="firstName,middleName,lastName,+phone"
                api-link="customers/GET_ALL"
                @itemSelected="customerSelected"
              />
            </b-col>
            <b-col>
              <b-form-group>
                <b-input-group
                  :prepend="$t('area')"
                  class="mb-2 mr-sm-2 mb-sm-0"
                >
                  <b-form-input
                    :disabled="true"
                    :placeholder="$t('area')"
                    :value="property.area + '/' + property.buildUpArea"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
              <b-form-group>
                <b-input-group
                  :prepend="$t('block')"
                  class="mb-2 mr-sm-2 mb-sm-0"
                >
                  <b-form-input
                    :placeholder="$t('streetWidth')"
                    v-model="property.streetWidth"
                  ></b-form-input>
                  <b-form-input
                    :placeholder="$t('streetNumber')"
                    v-model="property.streetNumber"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
              <b-form-group>
                <b-input-group
                  :prepend="$t('zone')"
                  class="mb-2 mr-sm-2 mb-sm-0"
                >
                  <b-form-input
                    :placeholder="$t('zone')"
                    v-model="property.zone"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <b-form-group>
                <b-input-group
                  :prepend="$t('contractNumber')"
                  class="mb-2 mr-sm-2 mb-sm-0"
                >
                  <b-form-input
                    :placeholder="$t('contractNumber')"
                    v-model="contractNumber"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
              <b-row>
                <b-col>
                  <b-form-group>
                    <b-input-group
                      :prepend="$t('initialPrice')"
                      class="mb-2 mr-sm-2 mb-sm-0"
                    >
                      <b-form-input
                        disabled
                        :placeholder="$t('initialPrice')"
                        v-model="finalPrice"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group>
                    <b-input-group
                      :prepend="$t('finalPrice')"
                      class="mb-2 mr-sm-2 mb-sm-0"
                    >
                      <b-form-input
                        disabled
                        :placeholder="$t('finalPrice')"
                        :value="finalPrice - discount"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-form-group>
                <b-input-group
                  :prepend="$t('installments')"
                  class="mb-2 mr-sm-2 mb-sm-0"
                >
                  <b-form-input
                    type="number"
                    :placeholder="$t('noOfInstallments')"
                    v-model="installmentsNumber"
                    @change="calculateInstallments"
                  ></b-form-input>
                  <b-form-input
                    type="number"
                    :placeholder="$t('periodOfInstallments')"
                    v-model="installmentPeriod"
                    @change="calculateInstallments"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-row>
              <b-col>
                <b-form-group>
                  <b-form-checkbox switch v-model="isCash"
                    >{{ $t("isCash") }}
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group>
                  <b-input-group :prepend="$t('date')">
                    <b-form-input
                      type="date"
                      v-model="installmentChangerDate"
                      @change="calculateInstallmentDays"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-row>

          <b-row v-if="!isCash">
            <b-col>
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>{{ $t("installment") }}</th>
                    <th>{{ $t("percentage") }}</th>
                    <th>{{ $t("amount") }}</th>
                    <th>{{ $t("date") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <!--First Pre Payment-->
                  <tr>
                    <th>{{ $t("prepayment") }} 1</th>
                    <th>
                      <b-input-group prepend="%">
                        <b-form-input
                          type="number"
                          v-model="prePayment1Percent"
                          @change="calculateInstallments"
                          :disabled="!prePayment1IsPercent"
                        ></b-form-input>
                      </b-input-group>
                      <b-input-group :prepend="$t('forgivePrice')">
                        <b-form-input
                          type="number"
                          v-model="prePayment1ForgivePrice"
                        ></b-form-input>
                      </b-input-group>
                    </th>
                    <th>
                      <b-input-group prepend="$">
                        <b-form-input
                          type="number"
                          v-model="prePayment1"
                          @change="calculateInstallments"
                          :disabled="prePayment1IsPercent"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button-group>
                            <b-button variant="info">
                              <b-form-checkbox
                                id="percentCheckbox"
                                name="percentCheckbox"
                                :value="true"
                                :unchecked-value="false"
                                v-model="prePayment1IsPercent"
                              >
                                {{ $t("percent") }}
                              </b-form-checkbox>
                            </b-button>
                          </b-button-group>
                        </b-input-group-append>
                      </b-input-group>
                    </th>
                    <th>
                      <b-input-group :prepend="$t('date')">
                        <b-form-input
                          type="date"
                          v-model="prePayment1Date"
                          @change="calculateInstallments"
                        ></b-form-input>
                      </b-input-group>
                    </th>
                  </tr>

                  <!--Second Pre Payment-->
                  <tr>
                    <th>{{ $t("payment") }} 2</th>
                    <th>
                      <b-input-group prepend="%">
                        <b-form-input
                          type="number"
                          v-model="prePayment2Percent"
                          @change="calculateInstallments"
                          :disabled="!prePayment2IsPercent"
                        ></b-form-input>
                      </b-input-group>
                      <b-input-group :prepend="$t('forgivePrice')">
                        <b-form-input
                          type="number"
                          v-model="prePayment2ForgivePrice"
                        ></b-form-input>
                      </b-input-group>
                    </th>
                    <th>
                      <b-input-group prepend="$">
                        <b-form-input
                          type="number"
                          v-model="prePayment2"
                          @change="calculateInstallments"
                          :disabled="prePayment2IsPercent"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button-group>
                            <b-button variant="info">
                              <b-form-checkbox
                                id="percentCheckbox2"
                                name="percentCheckbox2"
                                :value="true"
                                :unchecked-value="false"
                                v-model="prePayment2IsPercent"
                              >
                                {{ $t("percent") }}
                              </b-form-checkbox>
                            </b-button>
                          </b-button-group>
                        </b-input-group-append>
                      </b-input-group>
                    </th>
                    <th>
                      <b-input-group :prepend="$t('date')">
                        <b-form-input
                          type="date"
                          v-model="prePayment2Date"
                        ></b-form-input>
                      </b-input-group>
                    </th>
                  </tr>

                  <!--prepayment 3-->
                  <tr>
                    <th>{{ $t("payment") }} 3</th>
                    <th>
                      <b-input-group prepend="%">
                        <b-form-input
                          type="number"
                          v-model="prePayment3Percent"
                          @change="calculateInstallments"
                          :disabled="!prePayment3IsPercent"
                        ></b-form-input>
                      </b-input-group>
                      <b-input-group :prepend="$t('forgivePrice')">
                        <b-form-input
                          type="number"
                          v-model="prePayment3ForgivePrice"
                        ></b-form-input>
                      </b-input-group>
                    </th>
                    <th>
                      <b-input-group prepend="$">
                        <b-form-input
                          type="number"
                          v-model="prePayment3"
                          @change="calculateInstallments"
                          :disabled="prePayment3IsPercent"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button-group>
                            <b-button variant="info">
                              <b-form-checkbox
                                id="percentCheckbox3"
                                name="percentCheckbox3"
                                :value="true"
                                :unchecked-value="false"
                                v-model="prePayment3IsPercent"
                              >
                                {{ $t("percent") }}
                              </b-form-checkbox>
                            </b-button>
                          </b-button-group>
                        </b-input-group-append>
                      </b-input-group>
                    </th>
                    <th>
                      <b-input-group :prepend="$t('date')">
                        <b-form-input
                          type="date"
                          v-model="prePayment3Date"
                        ></b-form-input>
                      </b-input-group>
                    </th>
                  </tr>

                  <!--prepayment 4-->
                  <tr>
                    <th>{{ $t("payment") }} 4</th>
                    <th>
                      <b-input-group prepend="%">
                        <b-form-input
                          type="number"
                          v-model="prePayment4Percent"
                          @change="calculateInstallments"
                          :disabled="!prePayment4IsPercent"
                        ></b-form-input>
                      </b-input-group>
                      <b-input-group :prepend="$t('forgivePrice')">
                        <b-form-input
                          type="number"
                          v-model="prePayment4ForgivePrice"
                        ></b-form-input>
                      </b-input-group>
                    </th>
                    <th>
                      <b-input-group prepend="$">
                        <b-form-input
                          type="number"
                          v-model="prePayment4"
                          @change="calculateInstallments"
                          :disabled="prePayment4IsPercent"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button-group>
                            <b-button variant="info">
                              <b-form-checkbox
                                id="percentCheckbox4"
                                name="percentCheckbox4"
                                :value="true"
                                :unchecked-value="false"
                                v-model="prePayment4IsPercent"
                              >
                                {{ $t("percent") }}
                              </b-form-checkbox>
                            </b-button>
                          </b-button-group>
                        </b-input-group-append>
                      </b-input-group>
                    </th>
                    <th>
                      <b-input-group :prepend="$t('date')">
                        <b-form-input
                          type="date"
                          v-model="prePayment4Date"
                        ></b-form-input>
                      </b-input-group>
                    </th>
                  </tr>

                  <!--prepayment 5-->
                  <tr>
                    <th>{{ $t("payment") }} 5</th>
                    <th>
                      <b-input-group prepend="%">
                        <b-form-input
                          type="number"
                          v-model="prePayment5Percent"
                          @change="calculateInstallments"
                          :disabled="!prePayment5IsPercent"
                        ></b-form-input>
                      </b-input-group>
                      <b-input-group :prepend="$t('forgivePrice')">
                        <b-form-input
                          type="number"
                          v-model="prePayment5ForgivePrice"
                        ></b-form-input>
                      </b-input-group>
                    </th>
                    <th>
                      <b-input-group prepend="$">
                        <b-form-input
                          type="number"
                          v-model="prePayment5"
                          @change="calculateInstallments"
                          :disabled="prePayment5IsPercent"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button-group>
                            <b-button variant="info">
                              <b-form-checkbox
                                id="percentCheckbox5"
                                name="percentCheckbox5"
                                :value="true"
                                :unchecked-value="false"
                                v-model="prePayment5IsPercent"
                              >
                                {{ $t("percent") }}
                              </b-form-checkbox>
                            </b-button>
                          </b-button-group>
                        </b-input-group-append>
                      </b-input-group>
                    </th>
                    <th>
                      <b-input-group :prepend="$t('date')">
                        <b-form-input
                          type="date"
                          v-model="prePayment5Date"
                        ></b-form-input>
                      </b-input-group>
                    </th>
                  </tr>

                   <!--prepayment 6-->
                   <tr>
                    <th>{{ $t("payment") }} 6</th>
                    <th>
                      <b-input-group prepend="%">
                        <b-form-input
                          type="number"
                          v-model="prePayment6Percent"
                          @change="calculateInstallments"
                          :disabled="!prePayment6IsPercent"
                        ></b-form-input>
                      </b-input-group>
                      <b-input-group :prepend="$t('forgivePrice')">
                        <b-form-input
                          type="number"
                          v-model="prePayment6ForgivePrice"
                        ></b-form-input>
                      </b-input-group>
                    </th>
                    <th>
                      <b-input-group prepend="$">
                        <b-form-input
                          type="number"
                          v-model="prePayment6"
                          @change="calculateInstallments"
                          :disabled="prePayment6IsPercent"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button-group>
                            <b-button variant="info">
                              <b-form-checkbox
                                id="percentCheckbox6"
                                name="percentCheckbox6"
                                :value="true"
                                :unchecked-value="false"
                                v-model="prePayment6IsPercent"
                              >
                                {{ $t("percent") }}
                              </b-form-checkbox>
                            </b-button>
                          </b-button-group>
                        </b-input-group-append>
                      </b-input-group>
                    </th>
                    <th>
                      <b-input-group :prepend="$t('date')">
                        <b-form-input
                          type="date"
                          v-model="prePayment6Date"
                        ></b-form-input>
                      </b-input-group>
                    </th>
                  </tr>

                  
                   <!--prepayment 7-->
                   <tr>
                    <th>{{ $t("payment") }} 7</th>
                    <th>
                      <b-input-group prepend="%">
                        <b-form-input
                          type="number"
                          v-model="prePayment7Percent"
                          @change="calculateInstallments"
                          :disabled="!prePayment7IsPercent"
                        ></b-form-input>
                      </b-input-group>
                      <b-input-group :prepend="$t('forgivePrice')">
                        <b-form-input
                          type="number"
                          v-model="prePayment7ForgivePrice"
                        ></b-form-input>
                      </b-input-group>
                    </th>
                    <th>
                      <b-input-group prepend="$">
                        <b-form-input
                          type="number"
                          v-model="prePayment7"
                          @change="calculateInstallments"
                          :disabled="prePayment7IsPercent"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button-group>
                            <b-button variant="info">
                              <b-form-checkbox
                                id="percentCheckbox7"
                                name="percentCheckbox7"
                                :value="true"
                                :unchecked-value="false"
                                v-model="prePayment7IsPercent"
                              >
                                {{ $t("percent") }}
                              </b-form-checkbox>
                            </b-button>
                          </b-button-group>
                        </b-input-group-append>
                      </b-input-group>
                    </th>
                    <th>
                      <b-input-group :prepend="$t('date')">
                        <b-form-input
                          type="date"
                          v-model="prePayment7Date"
                        ></b-form-input>
                      </b-input-group>
                    </th>
                  </tr>

                  
                   <!--prepayment 8-->
                   <tr>
                    <th>{{ $t("payment") }} 8</th>
                    <th>
                      <b-input-group prepend="%">
                        <b-form-input
                          type="number"
                          v-model="prePayment8Percent"
                          @change="calculateInstallments"
                          :disabled="!prePayment8IsPercent"
                        ></b-form-input>
                      </b-input-group>
                      <b-input-group :prepend="$t('forgivePrice')">
                        <b-form-input
                          type="number"
                          v-model="prePayment8ForgivePrice"
                        ></b-form-input>
                      </b-input-group>
                    </th>
                    <th>
                      <b-input-group prepend="$">
                        <b-form-input
                          type="number"
                          v-model="prePayment8"
                          @change="calculateInstallments"
                          :disabled="prePayment8IsPercent"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button-group>
                            <b-button variant="info">
                              <b-form-checkbox
                                id="percentCheckbox8"
                                name="percentCheckbox8"
                                :value="true"
                                :unchecked-value="false"
                                v-model="prePayment8IsPercent"
                              >
                                {{ $t("percent") }}
                              </b-form-checkbox>
                            </b-button>
                          </b-button-group>
                        </b-input-group-append>
                      </b-input-group>
                    </th>
                    <th>
                      <b-input-group :prepend="$t('date')">
                        <b-form-input
                          type="date"
                          v-model="prePayment8Date"
                        ></b-form-input>
                      </b-input-group>
                    </th>
                  </tr>

                  
                   <!--prepayment 9-->
                   <tr>
                    <th>{{ $t("payment") }} 9</th>
                    <th>
                      <b-input-group prepend="%">
                        <b-form-input
                          type="number"
                          v-model="prePayment9Percent"
                          @change="calculateInstallments"
                          :disabled="!prePayment9IsPercent"
                        ></b-form-input>
                      </b-input-group>
                      <b-input-group :prepend="$t('forgivePrice')">
                        <b-form-input
                          type="number"
                          v-model="prePayment9ForgivePrice"
                        ></b-form-input>
                      </b-input-group>
                    </th>
                    <th>
                      <b-input-group prepend="$">
                        <b-form-input
                          type="number"
                          v-model="prePayment9"
                          @change="calculateInstallments"
                          :disabled="prePayment9IsPercent"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button-group>
                            <b-button variant="info">
                              <b-form-checkbox
                                id="percentCheckbox9"
                                name="percentCheckbox9"
                                :value="true"
                                :unchecked-value="false"
                                v-model="prePayment9IsPercent"
                              >
                                {{ $t("percent") }}
                              </b-form-checkbox>
                            </b-button>
                          </b-button-group>
                        </b-input-group-append>
                      </b-input-group>
                    </th>
                    <th>
                      <b-input-group :prepend="$t('date')">
                        <b-form-input
                          type="date"
                          v-model="prePayment9Date"
                        ></b-form-input>
                      </b-input-group>
                    </th>
                  </tr>

                  
                   <!--prepayment 10-->
                   <tr>
                    <th>{{ $t("payment") }} 10</th>
                    <th>
                      <b-input-group prepend="%">
                        <b-form-input
                          type="number"
                          v-model="prePayment10Percent"
                          @change="calculateInstallments"
                          :disabled="!prePayment10IsPercent"
                        ></b-form-input>
                      </b-input-group>
                      <b-input-group :prepend="$t('forgivePrice')">
                        <b-form-input
                          type="number"
                          v-model="prePayment10ForgivePrice"
                        ></b-form-input>
                      </b-input-group>
                    </th>
                    <th>
                      <b-input-group prepend="$">
                        <b-form-input
                          type="number"
                          v-model="prePayment10"
                          @change="calculateInstallments"
                          :disabled="prePayment10IsPercent"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button-group>
                            <b-button variant="info">
                              <b-form-checkbox
                                id="percentCheckbox10"
                                name="percentCheckbox10"
                                :value="true"
                                :unchecked-value="false"
                                v-model="prePayment10IsPercent"
                              >
                                {{ $t("percent") }}
                              </b-form-checkbox>
                            </b-button>
                          </b-button-group>
                        </b-input-group-append>
                      </b-input-group>
                    </th>
                    <th>
                      <b-input-group :prepend="$t('date')">
                        <b-form-input
                          type="date"
                          v-model="prePayment10Date"
                        ></b-form-input>
                      </b-input-group>
                    </th>
                  </tr>










                  <tr>
                    <th>{{ $t("deliveringKeys") }}</th>
                    <th>
                      <b-input-group prepend="%">
                        <b-form-input
                          type="number"
                          v-model="deliveryKeyPercent"
                          @change="calculateInstallments"
                          :disabled="!deliveryKeyIsPercent"
                        ></b-form-input>
                      </b-input-group>
                      <b-input-group :prepend="$t('forgivePrice')">
                        <b-form-input
                          type="number"
                          v-model="deliveryKeyForgivePrice"
                        ></b-form-input>
                      </b-input-group>
                    </th>
                    <th>
                      <b-input-group prepend="$">
                        <b-form-input
                          type="number"
                          v-model="deliveryKey"
                          @change="calculateInstallments"
                          :disabled="deliveryKeyIsPercent"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button-group>
                            <b-button variant="info">
                              <b-form-checkbox
                                v-model="deliveryKeyIsPercent"
                                id="deliveryKeyCheckbox"
                                name="deliveryKeyCheckbox"
                                :value="true"
                                :unchecked-value="false"
                              >
                                {{ $t("percent") }}
                              </b-form-checkbox>
                            </b-button>
                          </b-button-group>
                        </b-input-group-append>
                      </b-input-group>
                    </th>
                    <th>
                      <b-input-group :prepend="$t('date')">
                        <b-form-input
                          type="date"
                          v-model="deliveryKeyDate"
                        ></b-form-input>
                      </b-input-group>
                    </th>
                  </tr>
                  <tr>
                    <th>{{ $t("installments") }}</th>
                    <th>
                      <b-input-group prepend="%">
                        <b-form-input
                          type="number"
                          v-model="currentInstallmentsPercent"
                          disabled
                        ></b-form-input>
                      </b-input-group>
                      <br />
                      <b-input-group prepend="$">
                        <b-form-input
                          type="number"
                          :value="
                            (currentInstallmentsPercent / 100) * finalPrice
                          "
                          disabled
                        ></b-form-input>
                      </b-input-group>
                    </th>
                    <th colspan="2">
                      <b-input-group :prepend="$t('contractNote')">
                        <b-form-textarea
                          id="note"
                          v-model="buyContractNote"
                        ></b-form-textarea>
                      </b-input-group>
                    </th>
                  </tr>
                  <!-- Loop Here -->
                  <tr
                    v-for="installment in installments"
                    v-bind:key="installment.index"
                  >
                    <th>{{ installment.index }}</th>
                    <th colspan="1">
                      <b-input-group prepend="$">
                        <b-form-input
                          type="number"
                          v-model="installment.currentPayPrice"
                        ></b-form-input>
                      </b-input-group>
                    </th>
                    <th colspan="1">
                      <b-input-group :prepend="$t('forgivePrice')">
                        <b-form-input
                          type="number"
                          v-model="installment.currentForgivePrice"
                        ></b-form-input>
                      </b-input-group>
                    </th>
                    <th colspan="1">
                      <b-input-group :prepend="$t('date')">
                        <b-form-input
                          type="date"
                          v-model="installment.currentPayDate"
                        ></b-form-input>
                      </b-input-group>
                    </th>
                  </tr>
                  <!-- Loop Here -->
                </tbody>
              </table>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group>
                <b-input-group
                  :prepend="$t('discount')"
                  class="mb-2 mr-sm-2 mb-sm-0"
                >
                  <b-form-input
                    type="number"
                    :max="property.initialPrice"
                    min="0"
                    :placeholder="$t('discount')"
                    v-model="discount"
                    @change="calculateDiscount"
                    :disabled="discountByPercent"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group>
                <b-input-group
                  :prepend="$t('discount') + ' (%)'"
                  class="mb-2 mr-sm-2 mb-sm-0"
                >
                  <b-form-input
                    type="number"
                    max="100"
                    min="0"
                    :placeholder="$t('discount')"
                    v-model="percentDiscount"
                    @change="calculateDiscountPercent"
                    :disabled="!discountByPercent"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group>
                <b-form-checkbox
                  v-model="discountByPercent"
                  name="check-button"
                  switch
                  @change="!discountByPercent"
                >
                  {{ $t("percent") }}
                </b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group>
                <b-form-checkbox
                  v-model="showDiscount"
                  name="check-button"
                  switch
                  >{{ $t("showDiscount") }}
                </b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <div class="accordion" role="tablist">
                <b-card no-body class="mb-1">
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.withExpense variant="info">{{
                      $t("withExpense")
                    }}</b-button>
                  </b-card-header>
                  <b-collapse
                    id="withExpense"
                    accordion="withExpenseAccordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <b-form-group>
                        <b-input-group
                          :prepend="$t('title')"
                          class="mb-2 mr-sm-2 mb-sm-0"
                        >
                          <b-form-input
                            type="text"
                            :placeholder="$t('title')"
                            v-model="expenseTitle"
                          ></b-form-input>
                        </b-input-group>
                      </b-form-group>
                      <b-form-group>
                        <select-input
                          label="name"
                          id="propertyExpenseTypeId"
                          :name="$t('propertyExpenseType')"
                          api-link="propertyExpenseTypes/GET_ALL"
                          :required="true"
                          @itemSelected="(e) => (expenseTypeId = e)"
                        />
                      </b-form-group>
                      <b-form-group>
                        <b-input-group
                          :prepend="$t('amount')"
                          class="mb-2 mr-sm-2 mb-sm-0"
                        >
                          <b-form-input
                            type="number"
                            min="0"
                            :placeholder="$t('amount')"
                            v-model="expensePrice"
                          ></b-form-input>
                        </b-input-group>
                      </b-form-group>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
            </b-col>
          </b-row>
          <button
            class="btn btn-outline-primary col-md-3"
            type="submit"
            :disabled="isLoading"
            @click="onSubmit"
          >
            <i class="fas fa-plus"></i> {{ $t("create") }}
          </button>
        </b-card-body>
      </b-card>
    </v-content>
  </div>
</template>

<script>
import Content from "../../components/Content";
import ContentHeader from "../../components/ContentHeader";
import SelectInput from "../../components/Inputs/SelectInput";
import moment from "moment";
import Swal from "sweetalert2";
import { permissions } from "@/plugins/constants";

export default {
  name: "BuyContractsCreateZaitonPlus",
  components: { ContentHeader, "v-content": Content, SelectInput },
  data() {
    return {
      isLoading: false,
      installments: [],
      property: "",
      customer: 0,
      contractNumber: "0",
      installmentsNumber: 9,
      installmentPeriod: 1,
      prePayment1: 0,
      prePayment1ForgivePrice: 0,
      prePayment1Percent: 5,
      prePayment1IsPercent: true,
      prePayment1Date: this.$helpers.getCurrentDate(),
      installmentChangerDate: this.$helpers.getCurrentDate(),
      prePayment2: 0,
      prePayment2ForgivePrice: 0,
      prePayment2Percent: 5,
      prePayment2IsPercent: true,
      prePayment2Date: this.$helpers.getCurrentDate(6),
      prePayment3: 0,
      prePayment3ForgivePrice: 0,
      prePayment3Percent: 5,
      prePayment3IsPercent: true,
      prePayment3Date: this.$helpers.getCurrentDate(12),
      prePayment4: 0,
      prePayment4ForgivePrice: 0,
      prePayment4Percent: 5,
      prePayment4IsPercent: true,
      prePayment4Date: this.$helpers.getCurrentDate(18),

      prePayment5: 0,
      prePayment5ForgivePrice: 0,
      prePayment5Percent: 5,
      prePayment5IsPercent: true,
      prePayment5Date: this.$helpers.getCurrentDate(18),
      
      prePayment6: 0,
      prePayment6ForgivePrice: 0,
      prePayment6Percent: 5,
      prePayment6IsPercent: true,
      prePayment6Date: this.$helpers.getCurrentDate(18),
      
      prePayment7: 0,
      prePayment7ForgivePrice: 0,
      prePayment7Percent: 5,
      prePayment7IsPercent: true,
      prePayment7Date: this.$helpers.getCurrentDate(18),
      
      prePayment8: 0,
      prePayment8ForgivePrice: 0,
      prePayment8Percent: 5,
      prePayment8IsPercent: true,
      prePayment8Date: this.$helpers.getCurrentDate(18),

      prePayment9: 0,
      prePayment9ForgivePrice: 0,
      prePayment9Percent: 5,
      prePayment9IsPercent: true,
      prePayment9Date: this.$helpers.getCurrentDate(18),
      
      prePayment10: 0,
      prePayment10ForgivePrice: 0,
      prePayment10Percent: 5,
      prePayment10IsPercent: true,
      prePayment10Date: this.$helpers.getCurrentDate(18),




      installmentsPercent: 25,
      buyContractNote: "",
      deliveryKey: 0,
      deliveryKeyPercent: 25,
      deliveryKeyForgivePrice: 0,
      deliveryKeyIsPercent: true,
      deliveryKeyDate: this.$helpers.getCurrentDate(18),
      currentInstallmentsPercent: 25,
      discount: 0,
      percentDiscount: 0,
      discountByPercent: false,
      finalPrice: 0,
      showDiscount: false,
      expenseTitle: "",
      expenseTypeId: 0,
      expensePrice: 0,
      permissions: permissions,
      isCash: false,
    };
  },
  mounted() {
    this.calculateInstallments();
  },
  methods: {
    customerSelected(customerId) {
      this.customer = customerId;
    },
    propertySelected(property) {
      this.property = property;
      this.isLoading = true;
      this.$store
        .dispatch("buyContracts/GET_BUY_CONTRACT_NUMBER")
        .then((response) => {
          this.contractNumber = response.data;
          this.isLoading = false;
        })
        .catch(() => (this.isLoading = false));
      this.calculateInstallments();
    },
    calculateInstallmentDays() {
      console.log("heeeee");
      for (let index = 0; index < this.installments.length; index++) {
        this.installments[index].currentPayDate = moment(
          this.installmentChangerDate
        )
          .add(this.installmentPeriod * index, "M")
          .format("YYYY-MM-DD");
      }
    },
    calculateInstallments() {
      let customInstallments = [];
      let percent =
        parseFloat(this.deliveryKeyPercent) +
        parseFloat(this.prePayment1Percent) +
        parseFloat(this.prePayment2Percent) +
        parseFloat(this.prePayment3Percent) +
        parseFloat(this.prePayment4Percent) +
        parseFloat(this.prePayment5Percent) +
        parseFloat(this.prePayment6Percent) +
        parseFloat(this.prePayment7Percent) +
        parseFloat(this.prePayment8Percent) +
        parseFloat(this.prePayment9Percent) +
        parseFloat(this.prePayment10Percent);

      this.currentInstallmentsPercent = 100 - percent;
      let propertyInitial = 0;

      propertyInitial =
        ((this.property.finalPrice - this.discount) *
          (this.currentInstallmentsPercent / 100)) /
        this.installmentsNumber;

      this.prePayment2Date = moment(this.prePayment1Date)
        .add(6, "M")
        .format("YYYY-MM-DD");
      this.prePayment3Date = moment(this.prePayment1Date)
        .add(12, "M")
        .format("YYYY-MM-DD");
      this.prePayment4Date = moment(this.prePayment1Date)
        .add(18, "M")
        .format("YYYY-MM-DD");
      this.prePayment5Date = moment(this.prePayment1Date)
        .add(24, "M")
        .format("YYYY-MM-DD");
      this.deliveryKeyDate = moment(this.prePayment1Date)
        .add(18, "M")
        .format("YYYY-MM-DD");

      for (let i = 1; i <= this.installmentsNumber; i++) {
        customInstallments.push({
          isItPrePayment: false,
          isItKeyPayment: false,
          isPayed: false,
          paymentProcessType: "Installment",
          index: i,
          currentPayPrice: propertyInitial.toFixed(4),
          currentForgivePrice: 0,
          currentPayDate: moment(this.deliveryKeyDate)
            .add(this.installmentPeriod * i, "M")
            .format("YYYY-MM-DD"),
        });
      }
      this.installments = customInstallments;
      if (this.prePayment1IsPercent) {
        this.prePayment1 = (
          (this.prePayment1Percent / 100) *
          (this.property.finalPrice - this.discount)
        ).toFixed(4);
      } else {
        this.prePayment1Percent =
          (this.prePayment1 / (this.property.finalPrice - this.discount)) * 100;
      }
      if (this.prePayment2IsPercent) {
        this.prePayment2 = (
          (this.prePayment2Percent / 100) *
          (this.property.finalPrice - this.discount)
        ).toFixed(4);
      } else {
        this.prePayment2Percent =
          (this.prePayment2 / (this.property.finalPrice - this.discount)) * 100;
      }

      if (this.prePayment3IsPercent) {
        this.prePayment3 = (
          (this.prePayment3Percent / 100) *
          (this.property.finalPrice - this.discount)
        ).toFixed(4);
      } else {
        this.prePayment3Percent =
          (this.prePayment3 / (this.property.finalPrice - this.discount)) * 100;
      }

      if (this.prePayment4IsPercent) {
        this.prePayment4 = (
          (this.prePayment4Percent / 100) *
          (this.property.finalPrice - this.discount)
        ).toFixed(4);
      } else {
        this.prePayment4Percent =
          (this.prePayment4 / (this.property.finalPrice - this.discount)) * 100;
      }

      if (this.prePayment5IsPercent) {
        this.prePayment5 = (
          (this.prePayment5Percent / 100) *
          (this.property.finalPrice - this.discount)
        ).toFixed(4);
      } else {
        this.prePayment5Percent =
          (this.prePayment5 / (this.property.finalPrice - this.discount)) * 100;
      }

      if (this.deliveryKeyIsPercent) {
        this.deliveryKey = (
          (this.deliveryKeyPercent / 100) *
          (this.property.finalPrice - this.discount)
        ).toFixed(4);
      } else {
        this.deliveryKeyPercent =
          (this.deliveryKey / (this.property.finalPrice - this.discount)) * 100;
      }
      this.finalPrice = this.property.finalPrice;
    },
    onSubmit() {
      let customInstallments = [];
      if (this.isCash) {
        customInstallments.push({
          isItPrePayment: true,
          isItKeyPayment: false,
          isPayed: false,
          paymentProcessType: "Cash",
          currentPayPrice: this.property.finalPrice - this.discount,
          currentPayDate: this.prePayment1Date,
          currentForgivePrice: this.prePayment1ForgivePrice,
        });
      } else {
        customInstallments = this._.clone(this.installments);
        customInstallments.push({
          isItPrePayment: true,
          isItKeyPayment: false,
          isPayed: false,
          paymentProcessType: "Installment",
          index: 1,
          currentPayPrice: this.prePayment1,
          currentPayDate: this.prePayment1Date,
          currentForgivePrice: this.prePayment1ForgivePrice,
        });
        if (this.prePayment2 > 0) {
          customInstallments.push({
            isItPrePayment: true,
            isItKeyPayment: false,
            isPayed: false,
            paymentProcessType: "Cash",
            currentPayPrice: this.prePayment2,
            currentPayDate: this.prePayment2Date,
            currentForgivePrice: this.prePayment2ForgivePrice,
          });
        }
        if (this.prePayment3 > 0) {
          customInstallments.push({
            isItPrePayment: true,
            isItKeyPayment: false,
            isPayed: false,
            paymentProcessType: "Cash",
            currentPayPrice: this.prePayment3,
            currentPayDate: this.prePayment3Date,
            currentForgivePrice: this.prePayment3ForgivePrice,
          });
        }
        if (this.prePayment4 > 0) {
          customInstallments.push({
            isItPrePayment: true,
            isItKeyPayment: false,
            isPayed: false,
            paymentProcessType: "Cash",
            currentPayPrice: this.prePayment4,
            currentPayDate: this.prePayment4Date,
            currentForgivePrice: this.prePayment4ForgivePrice,
          });
        }
        if (this.prePayment5 > 0) {
          customInstallments.push({
            isItPrePayment: true,
            isItKeyPayment: false,
            isPayed: false,
            paymentProcessType: "Cash",
            currentPayPrice: this.prePayment5,
            currentPayDate: this.prePayment5Date,
            currentForgivePrice: this.prePayment5ForgivePrice,
          });
        }
        if (this.prePayment6 > 0) {
          customInstallments.push({
            isItPrePayment: true,
            isItKeyPayment: false,
            isPayed: false,
            paymentProcessType: "Cash",
            currentPayPrice: this.prePayment6,
            currentPayDate: this.prePayment6Date,
            currentForgivePrice: this.prePayment6ForgivePrice,
          });
        }
        if (this.prePayment7 > 0) {
          customInstallments.push({
            isItPrePayment: true,
            isItKeyPayment: false,
            isPayed: false,
            paymentProcessType: "Cash",
            currentPayPrice: this.prePayment7,
            currentPayDate: this.prePayment7Date,
            currentForgivePrice: this.prePayment7ForgivePrice,
          });
        }
        if (this.prePayment8 > 0) {
          customInstallments.push({
            isItPrePayment: true,
            isItKeyPayment: false,
            isPayed: false,
            paymentProcessType: "Cash",
            currentPayPrice: this.prePayment8,
            currentPayDate: this.prePayment8Date,
            currentForgivePrice: this.prePayment8ForgivePrice,
          });
        }
        if (this.prePayment9 > 0) {
          customInstallments.push({
            isItPrePayment: true,
            isItKeyPayment: false,
            isPayed: false,
            paymentProcessType: "Cash",
            currentPayPrice: this.prePayment9,
            currentPayDate: this.prePayment9Date,
            currentForgivePrice: this.prePayment9ForgivePrice,
          });
        }
        if (this.prePayment10 > 0) {
          customInstallments.push({
            isItPrePayment: true,
            isItKeyPayment: false,
            isPayed: false,
            paymentProcessType: "Cash",
            currentPayPrice: this.prePayment10,
            currentPayDate: this.prePayment10Date,
            currentForgivePrice: this.prePayment10ForgivePrice,
          });
        }




        if (this.deliveryKey > 0) {
          customInstallments.push({
            isItPrePayment: false,
            isItKeyPayment: true,
            isPayed: false,
            paymentProcessType: "DeliveryKey",
            currentPayPrice: this.deliveryKey,
            currentForgivePrice: this.deliveryKeyForgivePrice,
            currentPayDate: this.deliveryKeyDate,
          });
        }
      }
      let sum = this._.sumBy(customInstallments, (val) => {
        return parseFloat(val.currentPayPrice);
      });

      if (
        !(
          parseFloat(sum.toFixed(4)) + parseFloat(this.discount) <=
            this.property.finalPrice + 1 &&
          parseFloat(sum.toFixed(4)) + parseFloat(this.discount) >=
            this.property.finalPrice - 1
        )
      ) {
        Swal.fire({
          position: "middle-center",
          icon: "error",
          html:
            this.$t(
              "pleaseCheckInstallmentsTheSumOfInstallmentsIsNotEqualToInitialPropertyPrice"
            ) +
            "  <br />" +
            this.$t("propertyPrice") +
            ": " +
            this.property.finalPrice.toLocaleString() +
            " <br />" +
            this.$t("installments") +
            ": " +
            sum.toLocaleString() +
            "  <br />" +
            this.$t("difference") +
            ": " +
            (this.property.finalPrice - sum).toLocaleString(),
          showConfirmButton: true,
        });
        return false;
      }

      let propertyExpense;
      if (this.expenseTitle) {
        propertyExpense = {
          title: this.expenseTitle,
          byMain: true,
          mcPrice: this.expensePrice,
          qty: 1,
          mcTotalPrice: this.expensePrice,
          date: this.prePayment1Date,
          propertyExpenseTypeId: this.expenseTypeId,
        };
      } else {
        propertyExpense = null;
      }
      let data = {
        buyContract: {
          contractNumber: this.contractNumber,
          buyingDate: this.prePayment1Date,
          buyingPrice: this.property.finalPrice,
          buyType: this.isCash ? "Cash" : "Installment",
          isCancelled: false,
          isPrePaymentPayed: false,
          discount: this.discount,
          showDiscount: this.showDiscount,
          propertyId: this.property.id,
          customerId: this.customer,
          paymentProcess: customInstallments,
          note: this.buyContractNote
        },
        propertyExpense: propertyExpense,
      };
      this.isLoading = true;
      this.$store
        .dispatch("buyContracts/CREATE", data)
        .then(() => {
          this.$router.push({ name: "buyContracts" });
        })
        .catch(() => (this.isLoading = false));
    },
    calculateDiscount() {
      this.percentDiscount = (this.discount / this.property.finalPrice) * 100;
      this.calculateInstallments();
    },
    calculateDiscountPercent() {
      this.discount = (this.percentDiscount / 100) * this.property.finalPrice;
      this.calculateInstallments();
    },
  },
};
</script>
